import React from "react";
import { wishlistSnackbarActions, WishlistSnackbarType } from "halifax";
import { useDispatch, useSelector } from "react-redux";
import {
  wishlistManagementModalActions,
  WishlistToggleHeart as WishlistToggleHeartComponent,
} from "halifax";
import { wishlistsApi } from "@capone/common";
import { BoxProps } from "@material-ui/core";
import { StayType } from "redmond/hotels-module/interfaces";
import {
  FAVORITES_REMOVE_ITEM,
  FavoritesItemProperties,
  LodgingCollectionEnum,
} from "redmond";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { getFavoritesItemType } from "../common";

interface WishlistHeartToggleProps {
  listingId: string;
  listingImageUrl?: string;
  stayType: StayType;
  lodgingCollection?: LodgingCollectionEnum;
  style?: BoxProps;
}

export const WishlistToggleHeart = ({
  listingId,
  listingImageUrl,
  stayType,
  lodgingCollection,
  style,
}: WishlistHeartToggleProps) => {
  const dispatch = useDispatch();

  const wishlistId = useSelector(
    wishlistsApi.endpoints.getAllWishlistItemsByUser.select()
  )?.data?.get(listingId);

  const onAddClick = () => {
    dispatch(
      wishlistManagementModalActions.openModal({
        listingId: listingId,
        listingImageUrl: listingImageUrl,
        stayType: stayType,
        lodgingCollection: lodgingCollection,
      })
    );
  };

  const onRemoveClick = () => {
    trackEvent({
      eventName: FAVORITES_REMOVE_ITEM,
      properties: {
        item_id: listingId,
        item_type: getFavoritesItemType(
          stayType,
          lodgingCollection || LodgingCollectionEnum.NoCollection
        ),
      } as FavoritesItemProperties,
    });
    dispatch(
      wishlistSnackbarActions.showSnackbar({
        type: WishlistSnackbarType.REMOVE,
        wishlistId: wishlistId,
        listingId: listingId,
        stayType: stayType,
      })
    );
  };

  return (
    <WishlistToggleHeartComponent
      isWishlisted={Boolean(wishlistId)}
      style={style}
      listingId={listingId}
      stayType={stayType}
      onAddClick={onAddClick}
      onRemoveClick={onRemoveClick}
    />
  );
};
